<template>
  <div class="main">
    <div class="wrapper">
      <div class="navigation">
        <!-- <router-link to="/boleto/parcela-boleto"><img :src="icBack"></router-link> -->
        <p></p>
        <span>Boletos</span>
        <p></p>
        <!-- <router-link to="/home"><img :src="icClose"></router-link> -->
      </div>
      <div class="content">
        <div class="center">
          <div class="icon">
            <div class="inner-icon">
              <img :src="require('@/assets/svg/maquina.svg')" />
            </div>
          </div>
          <p>Para efetuar o pagamento, siga as instruções na maquininha.</p>
        </div>
      </div>

      <FooterGlobal></FooterGlobal>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
// IMAGES
import icNext from '@/assets/svg/ic-next.svg';
import icClose from '@/assets/svg/ic-close.svg';
import icBack from '@/assets/svg/ic-back.svg';

// COMPONENTS
import FooterGlobal from '@/components/Footer.vue';
import { saveTransaction } from '@/pinpad/boleto';
// import { useRouter } from 'vue-router'
import { openSupportTask } from '@/observability/observability'
import axios from 'axios'
import { pinpadUrl } from '@/helper/vars';



export default defineComponent({
  name: 'PagamentoBoletoCartao',
  components: {
    FooterGlobal
  },
  data() {
    return {
      next: icNext,
      icClose: icClose,
      icBack: icBack,
      selectedOptions: [],
    };
  },
  async mounted() {
    const router = this.$router; // ou useRouter() se preferir Composition

    const installmentSelect = JSON.parse(sessionStorage.getItem('installmentSelect'));
    const urlpinpad = process.env.VUE_APP_PINPAD_API_URL;

    const dadosBoleto = JSON.parse(sessionStorage.getItem('dadosBoleto'));
    const dadosPessoais = JSON.parse(sessionStorage.getItem('dadosPessoais'));

    console.log('DADOS PESSOAIS:', dadosPessoais)
    console.log('DADOS BOLETO:', dadosBoleto)
    console.log('installmentSelect:', installmentSelect)


    const payload = {
      valor: parseInt(installmentSelect.totalParcela * 100),
      tipoPagamento: "CREDITO",
      numParcelas: parseInt(installmentSelect.installments)
    };

    const config = {
      method: 'POST',
      url: `${urlpinpad}${pinpadUrl}`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload)
    };

    let purchase = {};

    try {
      const response = await axios(config);
      purchase = response.data;
      console.log('purchase', purchase);

      if (purchase.sucesso === true) {
        console.log('Vai chamar saveTransaction...');
        try {
          const saveResponse = await saveTransaction(purchase);
          purchase.orderNumber = saveResponse.data.autorizacao;
          console.log('saveTransaction retornou:', saveResponse);
        } catch (error) {
          openSupportTask('Erro ao gravar transação no portal', error);
          router.push('/boleto/pagamento-boleto-rejeitado');
          return;
        }
      }

      this.$store.dispatch('setReceipt', purchase);

      if (purchase.sucesso === true) {
        router.push('/boleto/pagamento-boleto-sucesso');
      } else if (purchase.sucesso === false) {
        router.push('/boleto/pagamento-boleto-rejeitado');
      } else {
        router.push('/home');
      }
    } catch (error) {
      openSupportTask('Erro ao efetuar pagamento no Pinpad', error);
      router.push('/home');
    }
  },
  methods: {}
});
</script>